import { Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { Shipment } from '@qwyk/shared-stores/shipments';

import { ShipmentAddress } from './shipment-addresses.models';
import * as ShipmentAddressesActions from './shipment-addresses.actions';
import * as ShipmentAddressesSelectors from './shipment-addresses.selectors';

@Injectable()
export class ShipmentAddressesFacade {
    /**
     * Combine pieces of state using createSelector,
     * and expose them as observables through the facade.
     */
    loading$ = this.store.pipe(
        select(ShipmentAddressesSelectors.getShipmentAddressesLoading)
    );
    allShipmentAddresses$ = this.store.pipe(
        select(ShipmentAddressesSelectors.getAllShipmentAddresses)
    );
    selectedShipmentAddresses$ = this.store.pipe(
        select(ShipmentAddressesSelectors.getSelected)
    );
    error$ = this.store.pipe(
        select(ShipmentAddressesSelectors.getShipmentAddressesError)
    );

    constructor(private store: Store) {}

    /**
     * Use the initialization action to perform one
     * or more tasks in your Effects.
     */
    public init(shipment: Shipment) {
        this.store.dispatch(ShipmentAddressesActions.init({ shipment }));
    }

    public selectAddress(shipmentAddress: ShipmentAddress): void {
        this.store.dispatch(
            ShipmentAddressesActions.selectShipmentAddress({ shipmentAddress })
        );
    }

    public updateAddress(
        shipment: Shipment,
        shipmentAddress: ShipmentAddress
    ): void {
        this.store.dispatch(
            ShipmentAddressesActions.updateShipmentAddress({
                shipment,
                shipmentAddress,
            })
        );
    }

    public unselectAddress(): void {
        this.store.dispatch(ShipmentAddressesActions.unselectShipmentAddress());
    }
}
